<template>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-8 p-2 pt-5 p-sm-5 mx-auto mt-3 mt-sm-5 cert-page-content">
    <div class="cert-article px-2 px-sm-4">
      <h3 class="mb-4">Phishing</h3>
      <p>
        Phishing is a type of social engineering attack often used to steal user data, including login credentials and
        credit card numbers. It occurs when an attacker, masquerading as a trusted entity, dupes a victim into opening
        an email, instant message, or text message. The recipient is then tricked into clicking a malicious link, which
        can lead to the installation of malware, the freezing of the system as part of a ransomware attack, or the
        revealing of sensitive information.
      </p>

      <h4 class="mt-5 mb-4">The most targeted industries are :</h4>
      <ul>
        <li>IT companies</li>
        <li>Financial institutions</li>
        <li>Payment portals</li>
        <li>Telecoms</li>
        <li>Delivering companies</li>
        <li>Social Medias</li>
        <li>e-commerce</li>
      </ul>

      <h4 class="mt-5 mb-4">The most popular phishing types are :</h4>
      <ul>
        <li>Mail phishing</li>
        <li>Spear phishing</li>
        <li>Whaling</li>
        <li>Smishing</li>
        <li>Vishing</li>
        <li>Pharming</li>
      </ul>
      <h4 class="mt-5 mb-4">How to prevent it</h4>
      <ul>
        <li>Train users to be vigilant and be able to detect phishing emails</li>
        <li>Never click email links from an unknown source and beware that phishing can also come from a friend</li>
        <li>Regular monitoring of the online accounts</li>
        <li>Regular change of password</li>
        <li>Always have the latest software patches</li>
        <li>Control the inbound and outbound traffic via firewalls</li>
        <li>Be aware of pop-up windows</li>
        <li>Never give out personal information over email</li>
        <li>Use AI that scans incoming messages, detect suspicious messages and quarantines them before reaching the destination</li>
        <li>Track the latest phishing attacks</li>
        <li>Unless you completely trust a site, be cautious in giving out a credit card</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuideIncident"
}
</script>
